import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@/hooks/useTheme';

export default function NotFoundPage() {
  const colors = useTheme();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, padding: 24, backgroundColor: colors.background }}>
      <h1 style={{ fontSize: 48, fontWeight: 800, color: colors.text, marginBottom: 8 }}>404</h1>
      <p style={{ fontSize: 16, color: colors.textSecondary, marginBottom: 24 }}>Cette page n'existe pas.</p>
      <Link to="/" style={{ color: '#ffffff', backgroundColor: '#ea2a33', padding: '12px 24px', borderRadius: 24, fontSize: 14, fontWeight: 600 }}>
        Retour à l'accueil
      </Link>
    </div>
  );
}
